<template>
  <div>
    <div class="pl-7 pt-4">
      <div class="font-secundaria headline font-weight-bold fontColor1--text">{{tabs[0].title}}</div>
      <div
        style="line-height: 8px"
        class="font-secundaria subtitle-2 fontColor1--text"
        v-if="!$vuetify.breakpoint.xs"
      >
        Home > {{tabs[0].nome}} > <span class="font-weight-bold"> {{tabNameSelected}} </span>
      </div>
    </div>
    <v-container pt-7 px-6 ma-0 fluid>
      <v-row no-gutters>
        <v-col>
          <v-card style="border-radius: 20px;" class="white">
            <v-card-title class="header-border pa-0 ma-0">
              <v-row class="ml-0" no-gutters align="start" justify="start" style="width: 0px">
                <v-col cols="auto">
                  <tabs-cadu
                    :tabs="tabs"
                    :currentTab="currentTab"
                    :borderColor="greenColor"
                    :textColor="greyColor"
                    :textColorActive="greenColor"
                  />
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4" lg="3" class="pb-0" :style="showLine">
                  <LeftTransacao :index="tabIndex" @changeAll="changeAll" />
                </v-col>
                <v-col cols="12" sm="12" md="8" lg="9" :class="$vuetify.breakpoint.xs ? 'pt-0 pb-6': 'pb-4'">
                  <RightTransacao :tabIndex="tabIndex" :tabName="tabNameSelected" />
                  <v-row
                    justify="end"
                    align="end"
                    class="mr-1"
                    v-if="tabNameSelected !== 'E-mail Áreas'"
                  >
                    <v-col cols="auto" v-if="false">
                      <button-cadu
                        @click="$router.push('/home')"
                        text="VOLTAR"
                        :backColor="$vuetify.theme.themes.light.primary2"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <error-modal v-model="error" :errObj="errObj" />
    <overlay-loading v-model="loadingOverlay" />
  </div>
</template>

<script>
import LeftTransacao from './Shared/LeftTransacaoOnline'
import RightTransacao from './Shared/RightTransacao'

export default {
  components: {
    LeftTransacao,
    RightTransacao
  },
  data () {
    return {
      tabs: [
        {
          title: 'TRANSAÇÕES ONLINE',
          nome: 'Transações Online',
          value: 'transOnline',
          disabled: false
        }
      ],
      currentTab: 'transOnline',
      tabIndex: 0,
      tabNameSelected: 'Atualização de Beneficários',
      greenColor: this.$vuetify.theme.themes.light.primary1,
      greyColor: '#9E9E9E',
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),

      tokenBearer: localStorage.getItem('tokenBearer'),
      linhaVertical: {
        'border-right': '1px solid #DEE2E6',
        height: '520px'
      },
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      loadingOverlay: false,
      showNovaUnimed: false
    }
  },
  methods: {
    changeAll (obj) {
      const name = obj.tabName
      const index = obj.index

      this.tabNameSelected = name
      this.tabIndex = index
    }
  },
  computed: {
    showLine () {
      return !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)
        ? this.linhaVertical
        : ''
    }
  }
}
</script>

<style lang="sass" scoped>
$corBorda: #E8E8E8

.header-border
  border-bottom: 2px solid $corBorda
</style>
